import { makeStyles } from 'tss-react/mui';
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Theme } from '@mui/material/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Panel from '../../../../components/panel/Panel';
import ForecastMonthlyInputsTable from '../../../../containers/tables/ForecastMonthlyInputsTable';
import { ApplicationState } from '../../../../store';
import { ceclstateForecastSingleMonthlyInputUpdate } from '../../../../store/ceclapi/actions';
import { CeclApiState, ForecastInput, ValidationError } from '../../../../store/ceclapi/types';
import { colors } from '../../../../theme';

const useStyles = makeStyles()((theme: Theme) =>
    ({
        paddingLess: {
            padding: 0,
        },
        title: {
            width: '100%',
            textAlign: 'left',
            paddingLeft: theme.spacing(2),
        },
        dialogDivider: {
            color: colors.black,
        }
    }));

export interface ForecastMonthlyInputsProps{
    inputsWithErrors?: ValidationError[];
    inputsFromCsv?: ForecastInput[];
}

const ForecastMonthlyInputs: React.FC<ForecastMonthlyInputsProps> = (props) => {
    const cecl = useSelector<ApplicationState, CeclApiState>((state) => state.cecl);
    const inputsFromCsv = props.inputsFromCsv;
    const { classes } = useStyles();
    const [monthlyInputs, setMonthlyInputs] = React.useState([] as ForecastInput[]);
    const dispatch = useDispatch();

    React.useEffect(()=> {
        if(inputsFromCsv){
            setMonthlyInputs(inputsFromCsv);

            // Update the redux store to prevent the data from becoming stale
            inputsFromCsv.forEach(input => {
                dispatch(ceclstateForecastSingleMonthlyInputUpdate(input));
            });
            
        }
    }, [inputsFromCsv, dispatch]);
    
    React.useEffect(() => {
        if (cecl.forecastAssumptions?.configuration?.config?.inputs) {
            setMonthlyInputs([...cecl.forecastAssumptions!.configuration!.config!.inputs!]);
        }
    }, []);

    React.useEffect(() => {
        if (cecl.forecastAssumptions?.configuration?.config?.inputs) {
            setMonthlyInputs(JSON.parse(JSON.stringify(cecl.forecastAssumptions!.configuration!.config!.inputs!)));
        }
    }, [cecl.forecastAssumptions?.configuration]);

    React.useEffect(() => {
        if (!monthlyInputs.length || !cecl.forecastAssumptions?.detail?.data) {
            return;
        }
      
        const currentInputs = JSON.parse(JSON.stringify(cecl.forecastAssumptions!.configuration.config.inputs));
        const newInputs = [...cecl.forecastAssumptions!.detail!.data.inputs!];

        for (let i = 0; i < newInputs!.length; i++) {
            for (let j = 0; j < currentInputs!.length; j++) {
                if (newInputs![i].name == currentInputs![j].name) {
                    currentInputs![j] = newInputs![i];
                }
            }
        }

        setMonthlyInputs(currentInputs);
    }, [cecl.forecastAssumptions?.detail]);

    React.useEffect(() => {
        const myInputs = [...monthlyInputs];

        if(myInputs.length == 0){
            return;
        }
     
        myInputs.forEach(input => {
            input.error = false
        });

        props.inputsWithErrors?.map(inputError => inputError.fieldName).forEach(inputName => {
            const inputIndex = myInputs.findIndex(input => input.name == inputName);
            if(inputIndex >= 0){
                myInputs[inputIndex].error = true;
            } 
        });

        setMonthlyInputs(myInputs);
    }, [props.inputsWithErrors])



    function handleTableEdit(event:any, rowIndex: number, colName: string) {
        const inputIndex = monthlyInputs.findIndex((input) => input.order == rowIndex + 1);
        if (inputIndex < 0) {
            return;
        }
        if (event === null || event === ''){
            event = '0';
        }

        const testString = event.replace(/,/g, "");
        const value = parseFloat((testString as unknown) as string);
        const newInputs = [...monthlyInputs];
        switch (colName) {
            case 'Ending Balance':
                newInputs[inputIndex].endingBalance = value;
                break;
            case 'Number Of Loans':
                newInputs[inputIndex].numberOfLoans = value;
                break;
            case 'Average Loan Rate (%)':
                newInputs[inputIndex].averageLoanRate = value;
                break;
            case 'Weighted Average Remaining Maturity (Months)':
                newInputs[inputIndex].weightedAverageRemainingMaturity = value;
                break;
            case 'Dollar Amount Of Interest Only Loans':
                newInputs[inputIndex].dollarAmountOfInterestOnlyLoans = value;
                break;
            default:
                break;
        }
        const input = newInputs[inputIndex];
        dispatch(ceclstateForecastSingleMonthlyInputUpdate(input));
        setMonthlyInputs(newInputs);
    }

    return (
        <div>
            <Panel className={classes.paddingLess}>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Typography className={classes.title} variant='h1'>Monthly Inputs</Typography>
                        <Divider variant="middle" className={classes.dialogDivider} />
                    </Grid>
                    <Grid item>
                        <ForecastMonthlyInputsTable inputs={monthlyInputs} handleTableEdit={handleTableEdit} />
                    </Grid>
                </Grid>
            </Panel>
        </div>
    );
};

export default ForecastMonthlyInputs;
